import type { AppProps } from 'next/app';

import { ModalProvider } from 'src/context/Modal/ModalProvider';
import { RcnUserProvider } from 'src/context/RcnUser/RcnUserProvider';
import { WildCardRouteProvider } from 'src/context/WildCardRoute/WildCardRouteProvider';

import BackToTop from 'src/components/basicContent/_BackToTop/BackToTop';
import ErrorBoundary from 'src/components/errors/ErrorBoundary/ErrorBoundary';

import 'modern-normalize/modern-normalize.css';
import 'src/styles/rcn-colours.css';
import 'src/styles/typography.css';
import 'src/styles/variables.css';
import 'src/styles/base.css';
import 'src/styles/utils.css';
import 'src/styles/backgrounds.css';
import 'src/styles/links.css';
import 'src/styles/padding.css';
import 'src/styles/headings.css';
import 'src/styles/buttons.css';

export default function App({ Component, pageProps }: AppProps): JSX.Element {
	return (
		<RcnUserProvider>
			<WildCardRouteProvider>
				<ModalProvider>
					<ErrorBoundary>
						<Component {...pageProps} />
					</ErrorBoundary>
				</ModalProvider>
			</WildCardRouteProvider>
			<BackToTop />
		</RcnUserProvider>
	);
}
